import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './home-page/home-page.component';

import { LoginScreenComponent } from './login-page/login-screen/login-screen.component';
import { LoginFormComponent } from './login-page/login-form/login-form.component';
import { OtpVerificationComponent } from './login-page/otp-verification/otp-verification.component';
import { ResetPasswordComponent } from './login-page/reset-password/reset-password.component';

import { DashboardComponent } from './sub-manu-page-components/dashboard/dashboard.component';

import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthGuard } from './shared/services/guard-services/auth.guard';
import { SubscriptionAccessGuard } from './shared/services/guard-services/subscription-access.guard';
import { CustomerInterfoceHomePageComponent } from './customer-interface/customer-interfoce-home-page/customer-interfoce-home-page.component';
import { ViewProfileComponent } from './sub-menu-bar-folder/view-profile/view-profile.component';
import { PersonalDetailsComponent } from './sub-manu-page-components/view-profile/personal-details/personal-details.component';
import { IdentityDocumentsComponent } from './sub-manu-page-components/view-profile/identity-documents/identity-documents.component';
import { ContactDetailsComponent } from './sub-manu-page-components/view-profile/contact-details/contact-details.component';
import { NotificationSettingsComponent } from './sub-manu-page-components/view-profile/notification-settings/notification-settings.component';
import { PasswordManagerComponent } from './sub-manu-page-components/view-profile/password-manager/password-manager.component';

import { OsmMapComponent } from './osm-map/osm-map.component';
import { MachineRegistrationFormComponent } from './machine/machine-registration-form/machine-registration-form.component';
import { ProjectsComponent } from './components/projects/projects.component';
// import { MapEditorComponent } from './components/map-editor/map-editor.component';
import { VendorListComponent } from './components/vendor-list/vendor-list.component';
import { AttendanceListComponent } from './attendance/attendance-list/attendance-list.component';
import { AddProjectComponent } from './components/projects/add-project/add-project.component';
import { ServicesListComponent } from './master/services/services-list/services-list.component';
import { MapeditorComponent } from './mapeditor/mapeditor.component';
import { OlmComponent } from './olm/olm.component';

import { AddStaffComponent } from './components/vendor-list/add-staff/add-staff.component';
import { CreateLeadComponent } from './leads/create-lead/create-lead.component';
import { LeadListComponent } from './leads/lead-list/lead-list.component';
import { CreateQuotesComponent } from './quotes/create-quotes/create-quotes.component';
import { QuotesListComponent } from './quotes/quotes-list/quotes-list.component';
import { CreateContactComponent } from './contacts/create-contact/create-contact.component';
import { ContactListComponent } from './contacts/contact-list/contact-list.component';
import { CreateImportComponent } from './imports/create-import/create-import.component';
import { NotificationListComponent } from './components/notification/notification-list/notification-list.component';
import { AddPortalBuilderComponent } from './components/portal-builder/add-portal-builder/add-portal-builder.component';
import { TenderListComponent } from './components/tender/tender-list/tender-list.component';
import { CreateTenderComponent } from './components/tender/create-tender/create-tender.component';
import { RoadProjectFormComponent } from './components/projects/road-project-form/road-project-form.component';
import { RoadProjectForm2Component } from './components/projects/road-project-form2/road-project-form2.component';
import { OrganizationComponent } from './components/vendor-list/organization/organization.component';
import { VendorAccountsListComponent } from './components/vendor-accounts/vendor-accounts-list/vendor-accounts-list.component';
import { AddVendorAccountComponent } from './components/vendor-accounts/add-vendor-account/add-vendor-account.component';
import { VendorResourcesHubComponent } from './components/vendor-accounts/vendor-resources-hub/vendor-resources-hub.component';
import { StaffListComponent } from './components/vendor-list/staff-list/staff-list.component';
import { MapEditorComponent } from './components/map-editor/map-editor.component';
import { GisEditorComponent } from './components/map/gis-editor/gis-editor.component';
import { AddUserComponent } from './components/vendor-list/add-user/add-user.component';
import { ProjectBinddingComponent } from './components/projects/project-bindding/project-bindding.component';
import { ProjectAwardComponent } from './components/projects/project-award/project-award.component';
import { SupportTicketComponent } from './components/support/support-ticket/support-ticket.component';
import { SupportTicketListComponent } from './components/support/support-ticket-list/support-ticket-list.component';
import { SupportTechnicalComponent } from './components/support/support-technical/support-technical.component';
import { PaymentListComponent } from './components/payment/payment-list/payment-list.component';
import { SubscriptionComponent } from './components/subscription/subscription/subscription.component';
import { ProgressReportComponent } from './components/progress-report/progress-report/progress-report.component';
import { ProgressReportListComponent } from './components/progress-report/progress-report-list/progress-report-list.component';
import { MonthlyBillingListComponent } from './components/monthly-billing/monthly-billing-list/monthly-billing-list.component';
import { MonthlyBillingComponent } from './components/monthly-billing/monthly-billing/monthly-billing.component';
import { ProjectClosureListComponent } from './components/project-closure/project-closure-list/project-closure-list.component';
import { ProjectClosureComponent } from './components/project-closure/project-closure/project-closure.component';
import { ExcelImportComponent } from './components/projects/excel-import/excel-import.component';
import { MapeditortestComponent } from './mapeditortest/mapeditortest.component';
import { RoleListComponent } from './components/role-list/role-list.component';
import { AddRoleComponent } from './components/add-role/add-role.component';
import { ProjectDetailComponent } from './components/projects/project-detail/project-detail.component';
import { WorkBreakdownStructureComponent } from './components/work-breakdown-structure/work-breakdown-structure.component';
import { WBSDeviationReportComponent } from './components/work-breakdown-structure/wbs-deviation-report/wbs-deviation-report.component';
import { WbsProjectListComponent } from './components/work-breakdown-structure/wbs-project-list/wbs-project-list.component';

import { OnboardingComponent } from "./onboarding/onboarding.component";
import { CompanyInfoComponent } from "./onboarding/company-info/company-info.component";
import { SignupFormComponent } from "./onboarding/Signup-form/signup-form.component";
import { EmailVerificationComponent } from "./onboarding/otp-verification/otp-verification.component";
import { PackageListComponent } from './components/packages/package-list/package-list.component';
import { PackageFormComponent } from './components/packages/package-form/package-form.component';
import { MultiOrganizationComponent } from './components/vendor-list/multi-organization/multi-organization.component';
import { SuccessPaymentComponent } from './components/payment/success-payment/success-payment.component';
import { FailurePaymentComponent } from './components/payment/failure-payment/failure-payment.component';
import { AddMultiProjectComponent } from './components/projects/add-multi-project/add-multi-project.component';
// import { AddDocProjectComponent } from './components/projects/add-doc-project/add-doc-project.component';
import { AddUserProjectComponent } from './components/projects/add-user-project/add-user-project.component';
import { AddWorkProjectComponent } from './components/projects/add-work-project/add-work-project.component';
import { BranchListComponent } from './components/vendor-list/branch-list/branch-list.component';
import { AddBranchComponent } from './components/vendor-list/add-branch/add-branch.component';
import { EditBranchComponent } from './components/vendor-list/edit-branch/edit-branch.component';
import { PlacePickerComponent } from './place-picker/place-picker.component';
import { MaterialCostComponent } from './components/projects/material-cost/material-cost.component';
import { MultiMachineRegistrationFormComponent } from './machine/multi-machine-registration-form/multi-machine-registration-form.component';
import { AddNewOrganizationComponent } from './components/vendor-list/add-new-organization/add-new-organization.component';
import { AddConstructionMaterialsComponent } from './components/vendor-list/add-construction-materials/add-construction-materials.component';
import { ConstructionMaterialsListComponent } from './components/vendor-list/construction-materials-list/construction-materials-list.component';
import { AddMachineComponent } from './machine/add-machine/add-machine.component';
import { MachineMasterComponent } from './machine/machine-master/machine-master.component';
import { AddMachineMasterComponent } from './machine/add-machine-master/add-machine-master.component';
import { CrewMachineMatrixComponent } from './machine/crew-machine-matrix/crew-machine-matrix.component';
import { MachineReservationListComponent } from './machine/machine-reservation-list/machine-reservation-list.component';
import { MaterialMasterComponent } from './components/projects/material-master/material-master.component';
import { BiddingComponent } from './components/projects/bidding/bidding.component';
import { AddDesignStageComponent } from './components/projects/design-stage/add-design-stage/add-design-stage.component';
import { DesignStageListComponent } from './components/projects/design-stage/design-stage-list/design-stage-list.component';
import { AddPlanningComponent } from './components/projects/planning/add-planning/add-planning.component';
import { PlanningListComponent } from './components/projects/planning/planning-list/planning-list.component';
import { NewProjectListComponent } from './components/projects/new-project-list/new-project-list.component';
import { AddNewProjectComponent } from './components/projects/add-new-project/add-new-project.component';
import { EstimationStageListComponent } from './components/projects/estimation-stage/estimation-stage-list/estimation-stage-list.component';
import { AddEstimationStageComponent } from './components/projects/estimation-stage/add-estimation-stage/add-estimation-stage.component';
import { AddInspectionStageComponent } from './components/projects/inspection-stage/add-inspection-stage/add-inspection-stage.component';
import { InspectionStageListComponent } from './components/projects/inspection-stage/inspection-stage-list/inspection-stage-list.component';
import { SegmentInspectionListComponent } from './components/projects/segment-inspection/segment-inspection-list/segment-inspection-list.component';
import { SegmentInspectionFormComponent } from './components/projects/segment-inspection/segment-inspection-form/segment-inspection-form.component';
import { SegmentInspectionDetailComponent } from './components/projects/segment-inspection/segment-inspection-detail/segment-inspection-detail.component';
import { PlmPavementProgressComponent } from './components/plm/plm-pavement-progress/plm-pavement-progress.component';
import { PlmResourceMapComponent } from './components/plm/plm-resource-map/plm-resource-map.component';
import { PlmClosureComponent } from './components/plm/plm-closure/plm-closure.component';
import { PlmOpsComponent } from './components/plm/plm-ops/plm-ops.component';
import { DomainSelectionComponent } from './subscriptionManager/domain-selection/domain-selection.component';
import { AddB1Component } from './components/projects/B1/add-b1/add-b1.component';
import { AddB2Component } from './components/projects/B2/add-b2/add-b2.component';
import { AddMiningPlanComponent } from './components/projects/mining-plan/add-mining-plan/add-mining-plan.component';
import { B1ListComponent } from './components/projects/B1/b1-list/b1-list.component';
import { B2ListComponent } from './components/projects/B2/b2-list/b2-list.component';
import { AddBiddingComponent } from './components/projects/bidding/add-bidding/add-bidding.component';
import { AddAwardComponent } from './components/projects/award/add-award/add-award.component';
import { AddPurchaseOrderComponent } from './components/projects/purchase-order/add-purchase-order/add-purchase-order.component';
import { AddSurveyComponent } from './components/projects/survey/add-survey/add-survey.component';
import { AddDeviationsReportComponent } from './components/projects/deviations-report/add-deviations-report/add-deviations-report.component';
import { AddPoAmendmentFormComponent } from './components/projects/po-amendment-form/add-po-amendment-form/add-po-amendment-form.component';
import { AddSIVComponent } from './components/projects/SIV/add-siv/add-siv.component';
import { AddSRVComponent } from './components/projects/SRV/add-srv/add-srv.component';
import { AddExecutionComponent } from './components/projects/execution/add-execution/add-execution.component';
import { AddInvoiceComponent } from './components/projects/invoice/add-invoice/add-invoice.component';
import { AddClosureComponent } from './components/projects/closure/add-closure/add-closure.component';
import { AddMonitoringComponent } from './components/projects/monitoring/add-monitoring/add-monitoring.component';
import { BomListComponent } from './bom-list/bom-list.component';
import { BomComponent } from './bom/bom.component';
import { AiBomComponent } from './components/ai-bom/ai-bom.component';
import { AiBoqComponent } from './components/ai-boq/ai-boq.component';
import { BoqListComponent } from './components/boq/boq-list/boq-list.component';
import { BoqFormComponent } from './components/boq/boq-form/boq-form.component';
import { BoqPlannedActualDeviationComponent } from './components/boq/boq-planned-actual-deviation/boq-planned-actual-deviation.component';
import { AlertListComponent } from './components/alerts/alert-list/alert-list.component';
import { ApprovalWorkflowComponent } from './approval-workflow/approval-workflow.component';
import { WorkLogComponent } from './work-log/work-log.component';
import { ClientListComponent } from './client-list/client-list.component';
import { DailyReportsListComponent } from './labour-mobilization/daily-reports-list/daily-reports-list.component';
import { DailyReportFormComponent } from './labour-mobilization/daily-report-form/daily-report-form.component';
import { MobilizationPlansListComponent } from './labour-mobilization/mobilization-plans-list/mobilization-plans-list.component';
import { MobilizationPlanFormComponent } from './labour-mobilization/mobilization-plan-form/mobilization-plan-form.component';
import { DeviationReportComponent } from './labour-mobilization/deviation-report/deviation-report.component';
import { BiddingListComponent } from './components/projects/bidding/bidding-list/bidding-list.component';
import { AwardListComponent } from './components/projects/award/award-list/award-list.component';
import { PurchaseOrderListComponent } from './components/projects/purchase-order/purchase-order-list/purchase-order-list.component';
import { WorkOrderListComponent } from './components/work-orders/work-order-list/work-order-list.component';
import { WorkOrderFormComponent } from './components/work-orders/work-order-form/work-order-form.component';
import { WorkOrderViewComponent } from './components/work-orders/work-order-view/work-order-view.component';
import { SurveyListComponent } from './components/projects/survey/survey-list/survey-list.component';
import { DeviationsReportListComponent } from './components/projects/deviations-report/deviations-report-list/deviations-report-list.component';
import { PoAmendmentFormListComponent } from './components/projects/po-amendment-form/po-amendment-form-list/po-amendment-form-list.component';
import { SIVListComponent } from './components/projects/SIV/siv-list/siv-list.component';
import { SRVListComponent } from './components/projects/SRV/srv-list/srv-list.component';
import { ExecutionListComponent } from './components/projects/execution/execution-list/execution-list.component';
import { InvoiceListComponent } from './components/projects/invoice/invoice-list/invoice-list.component';
import { MonitoringListComponent } from './components/projects/monitoring/monitoring-list/monitoring-list.component';
import { ClosureListComponent } from './components/projects/closure/closure-list/closure-list.component';
import { ProjectBillsComponent } from './components/project-bills/project-bills.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { PurchasePlanComponent } from './purchase-plan/purchase-plan.component';
import { GismapeditorComponent } from './gismapeditor/gismapeditor.component';
import { GisavieditorComponent } from './gisavieditor/gisavieditor.component';
import { OrgOrganizationComponent } from './components/vendor-list/org-organization/org-organization.component';
import { InvitedOrgsStatsComponent } from './components/vendor-list/invited-orgs-stats/invited-orgs-stats.component';
import { CadviewerComponent } from './cadviewer/cadviewer.component';
import { ClickupIntegrationComponent } from './components/integrations/clickup/clickup-integration.component';
import { IntegrationsHubComponent } from './components/integrations/integrations-hub/integrations-hub.component';
import { IntegrationSetupComponent } from './components/integrations/integration-setup/integration-setup.component';
import { BoqBiddingInviteComponent } from './components/boq/boq-bidding-invite/boq-bidding-invite.component';
import { BoqBiddingWrapperComponent } from './components/boq/boq-bidding-wrapper/boq-bidding-wrapper.component';
import { DocumentListComponent } from './components/documents/document-list/document-list.component';
import { ViewBidsPageComponent } from './components/boq/view-bids-page/view-bids-page.component';
import { BiddingDeviationReportPageComponent } from './components/boq/bidding-deviation-report-page/bidding-deviation-report-page.component';
import { VendorRankingDashboardComponent } from './components/vendor-ranking/vendor-ranking-dashboard/vendor-ranking-dashboard.component';
import { GeospatialShellComponent } from './components/geospatial/geospatial-shell/geospatial-shell.component';
import { GeospatialDashboardComponent } from './components/geospatial/geospatial-dashboard/geospatial-dashboard.component';
import { GisavimvpComponent } from './gisavimvp/gisavimvp.component';
import { ProjectPlanningDashboardComponent } from './project-planning-dashboard/project-planning-dashboard.component';
import { AddOrganizationComponent } from './components/vendor-list/add-organization/add-organization.component';
import { AssetManagementComponent } from './components/admin/asset-management/asset-management.component';
import { RoadBoQListComponent } from './components/road-boq/road-boq-list/road-boq-list.component';
import { RoadBoqFormComponent } from './components/road-boq/road-boq-form/road-boq-form.component';

const routes: Routes = [
  {
    path: '',
    component: LoginScreenComponent,
    children: [
      {
        path: '',
        component: LoginFormComponent,
      },
      {
        path: 'login',
        component: LoginFormComponent,
      },
      {
        path: 'otp-verification',
        component: OtpVerificationComponent,
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
      },

    ],
  },
  {
    path: 'subscription',
    component: DomainSelectionComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'plan',
    component: DomainSelectionComponent,
    // canActivate: [AuthGuard],
  },   {
    path: 'picker',
    component: PlacePickerComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'bidding',
    component: BoqBiddingWrapperComponent,
    children: [
      { path: 'invite/:token', component: BoqBiddingInviteComponent }
    ]
  },
  {
    path: "onboarding",
    component: OnboardingComponent,
    children: [
      {
        path: "",
        component: SignupFormComponent,
      }, {
        path: "signup-with-email",
        component: SignupFormComponent,
      }, {
        path: "verify-email",
        component: EmailVerificationComponent,
      }, {
        path: "company-onboarding",
        component: CompanyInfoComponent,
      }, {
        path: "staff-onboarding",
        component: AddUserComponent,
      },
    ],
  },
  {
    path: 'home',
    component: HomePageComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'b2',
        component: AddB2Component,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'b1',
        component: AddB1Component,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'b1-list',
        component: B1ListComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'b2-list',
        component: B2ListComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'add-mining-plan',
        component: AddMiningPlanComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'new-org',
        component: AddOrganizationComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'multi-machine-registration',
        component: MultiMachineRegistrationFormComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'machine-master',
        component: MachineMasterComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'machines',
        component: MachineMasterComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'machine-reservations',
        component: MachineReservationListComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'add-machine-master',
        component: AddMachineMasterComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'machine-owners',
        component: AddMachineMasterComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'machine-list',
        redirectTo: 'machine-master',
        pathMatch: 'full',
      },
      {
        path: 'user-machine',
        component: CrewMachineMatrixComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'document-list',
        component: DocumentListComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'ORGANIZATION','EMPLOYEE'],
        },
      },
      {
        path: 'document-list/:id',
        component: DocumentListComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'materials',
        redirectTo: 'material-list',
        pathMatch: 'full',
      },
      {
        path: 'material-list',
        component: ConstructionMaterialsListComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'add-material',
        component: AddConstructionMaterialsComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'edit-material/:id',
        component: AddConstructionMaterialsComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'view-material/:id',
        component: AddConstructionMaterialsComponent,
        canActivate: [AuthGuard],
        data: {
          mode: 'view',
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'machineRegistration',
        redirectTo: 'add-machine',
        pathMatch: 'full',
      },
      {
        path: 'staff',
        component: AddStaffComponent,
        canActivate: [AuthGuard],
        // data: {
        //   role: ['ADMIN', 'RESELLER'],
        // },
      },
      {
        path: 'material-cost',
        component: MaterialCostComponent,
        canActivate: [AuthGuard],
        // data: {
        //   role: ['ADMIN', 'RESELLER'],
        // },
      },
      {
        path: 'staff/edit/:id',
        component: AddStaffComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'multi-organization',
        component: MultiOrganizationComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
      // {
      //   path: 'add-doc-project/:id',
      //   component: AddDocProjectComponent,
      //   canActivate: [AuthGuard],
      //   data: {
      //     role: ['admin', 'manager', 'employee']
      //   },
      // },
      {
        path: 'add-user-project/:id',
        component: AddUserProjectComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
      {
        path: 'add-work-project/:id',
        component: AddWorkProjectComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
      {
        path: 'edit-organizations/:id',
        component: AddNewOrganizationComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
       {
        path: 'edit-organization/:id',
        component: OrgOrganizationComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
      {
        path: 'multi-edit-organization/:id',
        component: MultiOrganizationComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
      {
        path: 'add-user',
        component: AddUserComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
      {
        path: 'edit-user/:id',
        component: AddUserComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
      {
        path: 'company',
        component: OrganizationComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
      {
        path: 'invited-orgs',
        component: InvitedOrgsStatsComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
      {
        path: 'vendor/list',
        component: VendorAccountsListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'vendor/add',
        component: AddVendorAccountComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'vendor/resources',
        component: VendorResourcesHubComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'organization-branch-list/:id',
        component: BranchListComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
      {
        path: 'organization-add-branch/:id',
        component: AddBranchComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
      {
        path: 'organization-edit-branch/:id',
        component: EditBranchComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
      {
        path: 'employees',
        component: StaffListComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        }
      },
      {
        path: 'user',
        component: VendorListComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'add-machine',
        component: AddMachineComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'edit-machine/:id',
        component: AddMachineComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'view-machine/:id',
        component: AddMachineComponent,
        canActivate: [AuthGuard],
        data: {
          mode: 'view',
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'services-list',
        component: ServicesListComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['ADMIN', 'RESELLER'],
        },
      },
      {
        path: 'map',
        component: OsmMapComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'olm-map',
        component: OlmComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'quotes-list',
        component: QuotesListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'create-lead',
        component: CreateLeadComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'lead-list',
        component: LeadListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'create-quote',
        component: CreateQuotesComponent,
        canActivate: [AuthGuard],
      },

      {
        path: 'clients',
        component: ClientListComponent,
        canActivate: [AuthGuard],
      },
      // {
      //   path: 'user-list',
      //   component: UserListComponent,
      //   canActivate: [AuthGuard],
      // },
      {
        path: 'contact-list',
        component: ContactListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'create-contact',
        component: CreateContactComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'create-import',
        component: CreateImportComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'map-editor',
        redirectTo: 'geospatial',
        pathMatch: 'full',
      },
      {
        path: 'map-editor-libre',
        redirectTo: 'geospatial',
        pathMatch: 'full',
      },

      {
        path: 'map-editor-test',
        redirectTo: 'geospatial',
        pathMatch: 'full',
      },
      {
        path: 'map-editor-ol',
        redirectTo: 'geospatial',
        pathMatch: 'full',
      }, {
        path: 'map-editor-ol-avi',
        redirectTo: 'geospatial',
        pathMatch: 'full',
      },
      {
        path: 'gis-project/:id',
        component: GeospatialShellComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'geospatial-dashboard',
        component: GeospatialDashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'geospatial',
        component: GeospatialShellComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'geospatial/gis',
        redirectTo: 'geospatial',
        pathMatch: 'full',
      },
      {
        path: 'geospatial/lrs',
        redirectTo: 'geospatial',
        pathMatch: 'full',
      },
      {
        path: 'gis-mvp',
        component: GisavimvpComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'nhai-gis',
        redirectTo: 'gis-mvp',
        pathMatch: 'full',
      },
      {
        path: 'lrs',
        redirectTo: 'geospatial',
        pathMatch: 'full',
      },
      {
        path: 'asset-management',
        component: AssetManagementComponent,
        canActivate: [AuthGuard, SubscriptionAccessGuard],
      },{
        path: 'project-planning-dashboard',
        component: ProjectPlanningDashboardComponent
        },
      {
        path: 'map-editor-nx',
        redirectTo: 'geospatial',
        pathMatch: 'full',
      },{
        path: 'cadviewer',
        component: CadviewerComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'integrations',
        component: IntegrationsHubComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'integrations/clickup',
        component: ClickupIntegrationComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'integrations/primavera',
        component: IntegrationSetupComponent,
        canActivate: [AuthGuard],
        data: { integrationId: 'primavera' },
      },
      {
        path: 'integrations/microsoft-project',
        component: IntegrationSetupComponent,
        canActivate: [AuthGuard],
        data: { integrationId: 'microsoft-project' },
      },
      {
        path: 'integrations/cad',
        component: IntegrationSetupComponent,
        canActivate: [AuthGuard],
        data: { integrationId: 'cad' },
      },
      {
        path: 'attendance',
        component: AttendanceListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'projects',
        component: NewProjectListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-project',
        component: AddNewProjectComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'edit-project/:id',
        component: AddNewProjectComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'work-breakdown-structure/deviation-report',
        component: WBSDeviationReportComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'work-breakdown-structure/list',
        component: WbsProjectListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'work-breakdown-structure/:projectId',
        component: WorkBreakdownStructureComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'pre-planning-projects',
        component: ProjectsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'subscription',
        component: SubscriptionComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'payment-list',
        component: PaymentListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-biding',
        component: AddBiddingComponent,
        canActivate: [AuthGuard],
      },
        {
        path: 'biding-list',
        component: BiddingListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-award',
        component: AddAwardComponent,
        canActivate: [AuthGuard],
      },
       {
        path: 'award-list',
        component: AwardListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-purchase-order',
        component: AddPurchaseOrderComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'edit-purchase-order/:id',
        component: AddPurchaseOrderComponent,
        canActivate: [AuthGuard],
      },
       {
        path: 'purchase-order-list',
        component: PurchaseOrderListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'work-orders',
        component: WorkOrderListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'work-orders/new',
        component: WorkOrderFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'work-orders/:id/edit',
        component: WorkOrderFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'work-orders/:id',
        component: WorkOrderViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-survey',
        component: AddSurveyComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'edit-survey/:id',
        component: AddSurveyComponent,
        canActivate: [AuthGuard],
      },
       {
        path: 'survey-list',
        component: SurveyListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-deviations-report',
        component: AddDeviationsReportComponent,
        canActivate: [AuthGuard],
      },
        {
        path: 'deviations-report-list',
        component: DeviationsReportListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-po-amendment',
        component: AddPoAmendmentFormComponent,
        canActivate: [AuthGuard],
      },
        {
        path: 'po-amendment-list',
        component: PoAmendmentFormListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-siv',
        component: AddSIVComponent,
        canActivate: [AuthGuard],
      },
       {
        path: 'siv-list',
        component: SIVListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-srv',
        component: AddSRVComponent,
        canActivate: [AuthGuard],
      },
       {
        path: 'srv-list',
        component: SRVListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-execution',
        component: AddExecutionComponent,
        canActivate: [AuthGuard],
      },
        {
        path: 'execution-list',
        component: ExecutionListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-invoice',
        component: AddInvoiceComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'edit-invoice/:id',
        component: AddInvoiceComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'invoice-list',
        component: InvoiceListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'project-bills',
        component: ProjectBillsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-closure',
        component: AddClosureComponent,
        canActivate: [AuthGuard],
      },
        {
        path: 'closure-list',
        component: ClosureListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-monitoring',
        component: AddMonitoringComponent,
        canActivate: [AuthGuard],
      },
        {
        path: 'monitoring-list',
        component: MonitoringListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'project-biding',
        component: BiddingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'project-binding/add',
        component: ProjectBinddingComponent,
        canActivate: [AuthGuard],
        data: { mode: 'add' }
      },
      {
        path: 'project-binding/edit/:id',
        component: ProjectBinddingComponent,
        canActivate: [AuthGuard],
        data: { mode: 'edit' }
      },
      {
        path: 'project-binding/view/:id',
        component: ProjectBinddingComponent,
        canActivate: [AuthGuard],
        data: { mode: 'view' }
      },
      {
        path: 'project-award/add',
        component: ProjectAwardComponent,
        canActivate: [AuthGuard],
        data: { mode: 'add' }
      },
      {
        path: 'project-award/edit/:id',
        component: ProjectAwardComponent,
        canActivate: [AuthGuard],
        data: { mode: 'edit' }
      },
      {
        path: 'project-award/view/:id',
        component: ProjectAwardComponent,
        canActivate: [AuthGuard],
        data: { mode: 'view' }
      },
      {
        path: 'support-ticket-list',
        component: SupportTicketListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'support-ticket/add',
        component: SupportTicketComponent,
        canActivate: [AuthGuard],
        data: { mode: 'add' }
      },
      {
        path: 'support-ticket/edit/:id',
        component: SupportTicketComponent,
        canActivate: [AuthGuard],
        data: { mode: 'edit' }
      },
      {
        path: 'support-ticket/view/:id',
        component: SupportTicketComponent,
        canActivate: [AuthGuard],
        data: { mode: 'view' }
      },
      {
        path: 'support-technical/add',
        component: SupportTechnicalComponent,
        canActivate: [AuthGuard],
        data: { mode: 'add' }
      },
      {
        path: 'support-technical/edit/:id',
        component: SupportTechnicalComponent,
        canActivate: [AuthGuard],
        data: { mode: 'edit' }
      },
      {
        path: 'support-technical/view/:id',
        component: SupportTechnicalComponent,
        canActivate: [AuthGuard],
        data: { mode: 'view' }
      },

      {
        path: 'contact-us',
        component: ContactUsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'progress-report',
        component: ProgressReportListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-progress-report',
        component: ProgressReportComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'plm/pavement',
        component: PlmPavementProgressComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'plm/resources',
        component: PlmResourceMapComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'plm/closure',
        component: PlmClosureComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'plm/ops',
        component: PlmOpsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'monthly-billing',
        component: MonthlyBillingListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-monthly-billing',
        component: MonthlyBillingComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'project-closure-list',
        component: ProjectClosureListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-project-closure',
        component: ProjectClosureComponent,
        canActivate: [AuthGuard],
      },
      // {
      //   path: 'invoice-form-list',
      //   component: InvoiceFormListComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'add-invoice-form',
      //   component: InvoiceFormComponent,
      //   canActivate: [AuthGuard],
      // },
      {
        path: 'add-excel-import/:type',
        component: ExcelImportComponent,
        canActivate: [AuthGuard],
        data: {
          role: ['admin', 'manager', 'employee']
        },
      },
      {
        path: 'design-stage',
        component: AddDesignStageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'edit-design-stage/:id',
        component: AddDesignStageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'design-stage-list',
        component: DesignStageListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-inspection-stage',
        component: AddInspectionStageComponent,
        canActivate: [AuthGuard],
      },
        
      {
        path: 'edit-inspection-stage/:id',
        component: AddInspectionStageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'inspection-stage-list',
        component: InspectionStageListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'segment-inspections',
        component: SegmentInspectionListComponent,
        canActivate: [AuthGuard, SubscriptionAccessGuard],
      },
      {
        path: 'segment-inspection/new',
        component: SegmentInspectionFormComponent,
        canActivate: [AuthGuard, SubscriptionAccessGuard],
      },
      {
        path: 'segment-inspection/:id',
        component: SegmentInspectionDetailComponent,
        canActivate: [AuthGuard, SubscriptionAccessGuard],
      },
      {
        path: 'add-estimation-stage',
        component: AddEstimationStageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'edit-estimation-stage/:id',
        component: AddEstimationStageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'estimation-stage-list',
        component: EstimationStageListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-planning-stage',
        component: AddPlanningComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'edit-planning-stage/:id',
        component: AddPlanningComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'planning-stage-list',
        component: PlanningListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-pre-planning-project',
        component: AddProjectComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'edit-pre-planning-project/:id',
        component: AddProjectComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'view-project/:id',
        component: ProjectDetailComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-multi-project',
        component: AddMultiProjectComponent,
        canActivate: [AuthGuard],
      },

      {
        path: 'multi-project',
        component: RoadProjectFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'multi2-project',
        component: RoadProjectForm2Component,
        canActivate: [AuthGuard],
      },
      {
        path: 'notification',
        component: NotificationListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'portal-builder',
        component: AddPortalBuilderComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'tender',
        component: TenderListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'create-tender',
        component: CreateTenderComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'role-list',
        component: RoleListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'add-package',
        component: PackageFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'edit-package/:id',
        component: PackageFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'package-list',
        component: PackageListComponent,
        canActivate: [AuthGuard],
      },

      {
        path: 'add-role-and-permission',
        component: AddRoleComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'edit-role-and-permission/:id',
        component: AddRoleComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'create-tender',
        component: CreateTenderComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'bom-list',
        component: BomListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'bom',
        component: BomComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'ai-bom',
        component: AiBomComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'ai-boq',
        component: AiBoqComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'boq',
        component: BoqListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'boq-bidding/view-bids/:invitationId',
        component: ViewBidsPageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'vendor-ranking',
        component: VendorRankingDashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'boq-bidding/deviation-report/:invitationId',
        component: BiddingDeviationReportPageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'boq/new',
        component: BoqFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'boq/:id/edit',
        component: BoqFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'boq/:id/view',
        component: BoqFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'boq/:id/deviation',
        component: BoqPlannedActualDeviationComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'road-boq-list',
        component: RoadBoQListComponent,
        canActivate: [AuthGuard, SubscriptionAccessGuard],
      },
      {
        path: 'road-boq',
        redirectTo: 'road-boq-list',
        pathMatch: 'full',
      },
      {
        path: 'road-boq/new',
        component: RoadBoqFormComponent,
        canActivate: [AuthGuard, SubscriptionAccessGuard],
      },
      {
        path: 'road-boq/:id/edit',
        component: RoadBoqFormComponent,
        canActivate: [AuthGuard, SubscriptionAccessGuard],
      },
      {
        path: 'road-boq/:id',
        component: RoadBoqFormComponent,
        canActivate: [AuthGuard, SubscriptionAccessGuard],
      },
      {
        path: 'alerts',
        component: AlertListComponent,
        canActivate: [AuthGuard],
      },
      
      {
        path: 'workflow',
        component: ApprovalWorkflowComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'worklog',
        component: WorkLogComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'labour-mobilization/daily-reports/add',
        component: DailyReportFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'labour-mobilization/daily-reports/edit/:id',
        component: DailyReportFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'labour-mobilization/daily-reports/:id',
        component: DailyReportFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'labour-mobilization/daily-reports',
        component: DailyReportsListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'labour-mobilization/mobilization-plans/add',
        component: MobilizationPlanFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'labour-mobilization/mobilization-plans/edit/:id',
        component: MobilizationPlanFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'labour-mobilization/mobilization-plans/:id',
        component: MobilizationPlanFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'labour-mobilization/mobilization-plans',
        component: MobilizationPlansListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'labour-mobilization/deviation-report',
        component: DeviationReportComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'success',
        component: SuccessPaymentComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'failure',
        component: FailurePaymentComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manage-subscription',
        loadChildren: () => import('./subscription/subscription.module').then(m => m.SubscriptionModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'purchase-plan',
        component: PurchasePlanComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'profile',
        component: ViewProfileComponent,
        children: [
          { path: 'personal-details', component: PersonalDetailsComponent },
          { path: 'personal-details/:id', component: PersonalDetailsComponent },
          { path: 'contact-details', component: ContactDetailsComponent },
          {
            path: 'notification-settings',
            component: NotificationSettingsComponent,
          },
          {
             path: 'password-manager', 
             component: PasswordManagerComponent 
          },
          {
             path: 'identity-documents',
             component: IdentityDocumentsComponent
          },
          {
             path: 'identity-documents/:id',
             component: IdentityDocumentsComponent
          }
    ]},
    ],
  },

  // Customer IterFace
  {
    path: 'customer-interfaces',
    component: CustomerInterfoceHomePageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
